const LoyaltyScreens = {
  LOYALTY: {
    PATH: '/loyalty',
    TITLE: 'Loyalty',
    TITLE_ALT: 'Loyalty',
  },
  LIST_LOYALTY_REWARD: {
    PATH: '/loyalty/reward',
    HEADER_NAME: 'Reward',
    TITLE: 'Reward',
    TITLE_ALT: 'List Reward',
    PERMISSION: 'loyalty_reward.read',
  },
  ARRANGE_LOYALTY_REWARD: {
    PATH: '/loyalty/reward/arrange-position',
    HEADER_NAME: 'Arrange Position',
    TITLE: 'Arrange Position',
    TITLE_ALT: 'Arrange Position',
    PERMISSION: 'loyalty_reward.read'
  },
  ADD_LOYALTY_REWARD: {
    PATH: '/loyalty/reward/add',
    HEADER_NAME: 'Reward',
    TITLE: 'Create Reward',
    TITLE_ALT: 'Create Reward',
    PERMISSION: 'loyalty_reward.create',
  },
  EDIT_LOYALTY_REWARD: {
    PATH: '/loyalty/reward/edit/:id',
    HEADER_NAME: 'Reward',
    TITLE: 'Edit Reward',
    TITLE_ALT: 'Edit Reward',
    PERMISSION: 'loyalty_reward.update',
  },
  DETAIL_LOYALTY_REWARD: {
    PATH: '/loyalty/reward/detail/:id',
    HEADER_NAME: 'Reward',
    TITLE: 'Reward Detail',
    TITLE_ALT: 'Reward Detail',
    PERMISSION: 'loyalty_reward.read',
  },
  VIEW_VOUCHER_LOYALTY_REWARD: {
    PATH: '/loyalty/reward/voucher/:id',
    HEADER_NAME: 'Reward',
    TITLE: 'Voucher List',
    TITLE_ALT: 'Voucher List',
    PERMISSION: 'loyalty_reward.read',
  },
  LIST_POINT_MATRIX: {
    PATH: '/loyalty/point-matrix',
    HEADER_NAME: 'Point Matrix',
    TITLE: 'Point Matrix',
    TITLE_ALT: 'List Point Matrix',
    PERMISSION: 'loyalty_point_matrix.read',
  },
  ADD_POINT_MATRIX: {
    PATH: '/loyalty/point-matrix/add',
    HEADER_NAME: 'Point Matrix',
    TITLE: 'Create Point Matrix',
    TITLE_ALT: 'Create Point Matrix',
    PERMISSION: 'loyalty_point_matrix.create',
  },
  EDIT_POINT_MATRIX: {
    PATH: '/loyalty/point-matrix/edit/:id',
    HEADER_NAME: 'Point Matrix',
    TITLE: 'Edit Point Matrix',
    TITLE_ALT: 'Edit Point Matrix',
    PERMISSION: 'loyalty_point_matrix.update',
  },
  DETAIL_POINT_MATRIX: {
    PATH: '/loyalty/point-matrix/detail/:id',
    HEADER_NAME: 'Point Matrix',
    TITLE: 'Detail Point Matrix',
    TITLE_ALT: 'Detail Point Matrix',
    PERMISSION: 'loyalty_point_matrix.read',
  },
  LIST_LOYALTY_MISSION: {
    PATH: '/loyalty/mission',
    HEADER_NAME: 'List Mission',
    TITLE: 'Mission',
    TITLE_ALT: 'Mission',
    PERMISSION: 'loyalty_mission.read'
  },
  ARRANGE_LOYALTY_MISSION: {
    PATH: '/loyalty/mission/arrange-position',
    HEADER_NAME: 'Arrange Position',
    TITLE: 'Arrange Position',
    TITLE_ALT: 'Arrange Position',
    PERMISSION: 'loyalty_mission.read'
  },
  DETAIL_LOYALTY_MISSION: {
    PATH: '/loyalty/mission/detail/:id',
    HEADER_NAME: 'Mission Detail',
    TITLE: 'Mission Detail',
    TITLE_ALT: 'Mission Detail',
    PERMISSION: 'loyalty_mission.read'
  },
  ADD_LOYALTY_MISSION: {
    PATH: '/loyalty/mission/add',
    HEADER_NAME: 'Create Mission',
    TITLE: 'Create Mission',
    TITLE_ALT: 'Create Mission',
    PERMISSION: 'loyalty_mission.create'
  },
  EDIT_LOYALTY_MISSION: {
    PATH: '/loyalty/mission/edit/:id',
    HEADER_NAME: 'Mission',
    TITLE: 'Edit Mission',
    TITLE_ALT: 'Edit Mission',
    PERMISSION: 'loyalty_mission.update'
  },
  ADD_MISSION_CONTENT: {
    PATH: '/loyalty/mission/add/:contentId/:step',
    HEADER_NAME: 'Create Mission',
    TITLE: 'Create Mission',
    TITLE_ALT: 'Create Mission',
    PERMISSION: 'loyalty_mission.create'
  },
  EDIT_MISSION_CONTENT: {
    PATH: '/loyalty/mission/edit/:id/:contentId/:step',
    HEADER_NAME: 'Edit Mission',
    TITLE: 'Edit Mission',
    TITLE_ALT: 'Edit Mission',
    PERMISSION: 'loyalty_mission.update'
  },
  LIST_LOYALTY_CAMPAIGN: {
    PATH: '/loyalty/campaign',
    HEADER_NAME: 'Active Campaign',
    TITLE: 'Campaign',
    TITLE_ALT: 'Active Campaign',
    PERMISSION: 'loyalty_campaign.read'
  },
  ADD_LOYALTY_CAMPAIGN: {
    PATH: '/loyalty/campaign/add',
    HEADER_NAME: 'Create Campaign',
    TITLE: 'Create Campaign',
    TITLE_ALT: 'Create Campaign',
    PERMISSION: 'loyalty_campaign.create'
  },
  EDIT_LOYALTY_CAMPAIGN: {
    PATH: '/loyalty/campaign/edit/:id',
    HEADER_NAME: 'Campaign',
    TITLE: 'Edit Campaign',
    TITLE_ALT: 'Edit Campaign',
    PERMISSION: 'loyalty_campaign.update'
  },
  LIST_LOYALTY_CAMPAIGN_HISTORY: {
    PATH: '/loyalty/campaign/history',
    HEADER_NAME: 'History Campaign',
    TITLE: 'Campaign',
    TITLE_ALT: 'Campaign',
    PERMISSION: 'loyalty_campaign.read'
  },
  DETAIL_LOYALTY_CAMPAIGN_HISTORY: {
    PATH: '/loyalty/campaign/history/detail/:id',
    HEADER_NAME: 'Campaign Detail',
    TITLE: 'Detail',
    TITLE_ALT: 'Detail',
    PERMISSION: 'loyalty_campaign.read'
  },
}

export default LoyaltyScreens
